module.exports = __webpack_public_path__ + "static/media/edit.cc74f1cc.svg";